<template>
    <ZDJPage v-bind:target-uri="$route.path.substring('/gamezone'.length)"/>
</template>
<style scoped lang="scss">
    .tournaments-container{
        width: 100%;
        display: inline-block;
        position: relative;
        min-height: 100vh;
    }
</style>
<script>
    import ZDJPage from "@/components/ZDJPage/ZDJPage";
    import i18n from '@/i18n';

    export default {
        name: 'Turnee',
        components: {ZDJPage},
        data() {
            return {
                targetUri: ''
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>